import classnames from 'classnames';
import React from 'react';

import '@eika/icon-style';

import IconTypes from './IconTypes';

export interface IconProps {
    type: IconTypes;
    // @default 'icon--24'
    className?: string;
    ariaLabel?: string;
    wrapperClassName?: string;
}

const Icon = ({ type, className = 'icon--24', ariaLabel, wrapperClassName }: IconProps): JSX.Element => {
    const optionalAriaLabel = ariaLabel ? { 'aria-label': ariaLabel } : {};
    return (
        <span className={classnames('sgw-icon', wrapperClassName)}>
            <span className={classnames('icon', className, `icon--${type}`)} role="img" {...optionalAriaLabel} />
        </span>
    );
};

export default Icon;
